import { hireTalentPaths } from "../routes/hire-talent";
import { useLocation, useNavigate } from "react-router-dom";
import LogoutConfirmationModal from "../components/Modals/common/webinar/LogoutConfirmationModal";
import { enterPrisesPaths } from "../routes/enterprises";
import { disconnectSocket } from "../redux/features/chat/socket";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { getProfile, getToken, setProfile } from "../utils/pip";
import { fetchHireTalentProfile } from "../redux/features/hire-talent/actions/authAction";
import { normalizeHireTalentProfile } from "../utils/hireTalentProfile";

const HireTalentLayout = ({ children, user }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profile = getProfile("hire-talent") || {};
  const profileImage =
    profile?.profile_image || "/assets/img/user_profile.png";
  const profileName =
    profile?.full_name ||
    profile?.primary_contact_name ||
    profile?.email ||
    "";

  useEffect(() => {
    const token = getToken("hire-talent");
    if (!token) return;
    dispatch(fetchHireTalentProfile()).then((res) => {
      const data = res?.payload?.data;
      if (data) {
        const normalized = normalizeHireTalentProfile({
          ...profile,
          ...data,
        });
        setProfile("hire-talent", normalized);
      }
    });
  }, [dispatch]);

  const handleLogout = () => {
    localStorage.removeItem("hire-talent_profile_nuvio");
    localStorage.removeItem("hire-talent_token_nuvio");
    disconnectSocket();
    navigate(enterPrisesPaths?.Enterprise);
  };

  return (
    <>
      <div class="ct_dash_header ct_px_40">
        <div class="ct_dash_logo">
          <a onClick={() => navigate(enterPrisesPaths?.Enterprise)}>
            <img src="/assets/img/Nuvio_logo.png" alt="" />
          </a>
        </div>
        <ul class="ct_right_dash_option">
          <li onClick={()=>{
            navigate(hireTalentPaths?.Inbox)
          }}>
            <a>
              <i class="fa-solid fa-comment"></i>
            </a>
          </li>
          <li>
            <a>
              <i class="fa-solid fa-bell"></i>
            </a>
          </li>
          <li>
            <div class="ct_right_dropdown dropdown">
              <button
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div class="d-flex align-items-center">
                  <img
                    src={profileImage}
                    alt=""
                    class="ct_img_30"
                  />
                  {profile?.company_name ? (
                    <span class="ms-2">{profile.company_name}</span>
                  ) : profileName ? (
                    <span class="ms-2">{profileName}</span>
                  ) : null}
                </div>
                <i class="fa-solid fa-angle-down ms-auto"></i>
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li>
                  <a class="dropdown-item" onClick={() => navigate(hireTalentPaths?.Profile)}>
                    My Profile
                  </a>
                </li>
                <li>
                  <a class="dropdown-item">Change Password</a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    data-bs-toggle="modal"
                    data-bs-target="#ct_logout_admin"
                  >
                    Log Out
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
      <div class="ct_dash_nav ct_px_40">
        <ul>
          {[
            { label: "Dashboard", route: hireTalentPaths?.Dashboard },
            { label: "Profile", route: hireTalentPaths?.Profile },
            { label: "Job Posts", route: hireTalentPaths?.PostJobs },
            { label: "Applicants", route: hireTalentPaths?.Applicants },
            { label: "Match Talent", route: "" },
            { label: "Projects", route: hireTalentPaths?.MyProjects },
            { label: "Inbox", route: hireTalentPaths?.Inbox },
            { label: "Calander", route: "" },
            { label: "Setting", route: hireTalentPaths?.Settings },
          ]?.map((item, index) => (
            <li onClick={() => navigate(item?.route)}>
              <a className={pathname == item?.route ? "active" : ""}>
                {item?.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
      {children}
      <LogoutConfirmationModal
        id="ct_logout_admin"
        title="Logout"
        onConfirm={handleLogout}
      />
    </>
  );
};

export default HireTalentLayout;

